import { get, round } from 'lodash';
import { hasPlaceholder } from '@wix/wix-emails-placeholders';
import { SectionType } from '../../types';
import { getMessageWidth } from '../../utils/get-message-width';
import { getSectionMarginAsObject, getSectionPaddingAsObject, } from '../../utils/get-section-padding';
import { addHttps } from '../../utils/add-https';
import { getImageSrc, isGif, getImageWidth } from '../get-image/image-utils';
import { calculateImagePaddings } from './calculate-image-paddings';
const AVATAR_SIZE = 60;
const WIDTH_AUTO = 'auto';
const getImageHeightIfAvailable = (region, newWidth) => {
    const width = get(region, 'data.width', false);
    const height = get(region, 'data.height', false);
    if (width && height && newWidth !== WIDTH_AUTO) {
        return round((height / width) * newWidth);
    }
    return undefined;
};
export const getImageMaxWidth = ({ composerData, columnPadding, numberOfColumns, columnWidth, userOverrides, }) => {
    const messageContentWidth = getMessageWidth(composerData, composerData.styles.css);
    const { left: paddingLeft, right: paddingRight } = getSectionPaddingAsObject(composerData.styles.css, SectionType.mix, userOverrides);
    const { left: marginLeft, right: marginRight } = getSectionMarginAsObject(composerData.styles.css, SectionType.mix);
    const mixRegionWidth = messageContentWidth -
        (paddingLeft || 0) -
        (paddingRight || 0) -
        (marginRight || 0) -
        (marginLeft || 0);
    const spacesBetweenColumns = parseInt(columnPadding, 10) * 2 * (numberOfColumns - 1);
    const actualRegionWidth = mixRegionWidth - spacesBetweenColumns;
    return Math.floor((actualRegionWidth / 100) * columnWidth);
};
export const getImage = ({ region, composerData, getColumnOfRegion, numberOfColumns = 2, columnWidth = 50, balancedColumnPaddings = { left: 0, right: 0 }, userOverrides, replaceImagePlaceholders, }) => {
    const column = getColumnOfRegion();
    const columnPadding = balancedColumnPaddings[column] || balancedColumnPaddings.left;
    const maxWidth = getImageMaxWidth({
        composerData,
        numberOfColumns,
        columnPadding,
        columnWidth,
        userOverrides,
    });
    const naturalImageWidth = region.data.width ? region.data.width : maxWidth;
    const maxContentWidth = naturalImageWidth >= maxWidth ? maxWidth : naturalImageWidth;
    const src = getImageSrc({
        region,
        fallbackUrl: composerData.styles?.settings?.image?.url ?? '',
        maxContentWidth,
        isMix: true,
        replaceImagePlaceholders,
    });
    const imageWidth = getImageWidth(region, maxContentWidth);
    const imageProps = {};
    const { imagePaddingLeft, imagePaddingRight, outlookImagePaddingLeft, outlookImagePaddingRight, adjustedimageWidth, } = calculateImagePaddings(region, imageWidth, maxWidth);
    if (region.data.placeholderPreviewType === 'avatar') {
        imageProps.width = AVATAR_SIZE;
        imageProps.height = AVATAR_SIZE;
        imageProps.imgStyle = {
            borderRadius: '100%',
            height: `${AVATAR_SIZE}px`,
        };
    }
    else {
        imageProps.width = adjustedimageWidth;
        if (isGif(src.src)) {
            imageProps.height = getImageHeightIfAvailable(region, imageProps.width);
        }
    }
    const srcPlaceholder = region.data.relativeUri || region.data.url;
    return {
        type: 'image',
        regionId: region.regionId,
        src: addHttps(src.src),
        srcPlaceholder: hasPlaceholder(srcPlaceholder) ? srcPlaceholder : '',
        link: region.data.imageLink,
        mandatory: region.mandatory,
        outlookImagePaddingLeft,
        outlookImagePaddingRight,
        imagePaddingLeft,
        imagePaddingRight,
        ...imageProps,
    };
};
//# sourceMappingURL=get-image.js.map